module.exports = __webpack_public_path__ + "static/media/ai.8670d30b.svg";